module.exports = __webpack_public_path__ + "assets/images/menuIcons/menuBeacon4_ru.png";